<template>
  <discount-promo-notification-box v-if="eligibleForDiscountPromotion"/>
  <free-months-benefit-notification-box v-else-if="benefitType === BENEFIT_TYPES.FREE_MONTHS"/>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DiscountPromoNotificationBox from './DiscountPromoNotificationBox.vue';
import FreeMonthsBenefitNotificationBox from './FreeMonthsBenefitNotificationBox.vue';

export default {
  name: 'BenefitNotificationBox',
  components: {
    DiscountPromoNotificationBox,
    FreeMonthsBenefitNotificationBox,
  },
  computed: {
    ...mapState('benefits', ['benefitType']),
    ...mapGetters('benefits', ['BENEFIT_TYPES']),
    ...mapState('discountPromotion', ['eligibleForDiscountPromotion']),
  },
};
</script>

<style scoped lang="scss">
</style>
